import React, { useState, useRef, Component } from "react";
import { useConnector } from 'react-instantsearch-hooks-web';
import connectRange from 'instantsearch.js/es/connectors/range/connectRange';
import Slider from '@mui/material/Slider';



export function useRangeSlider(props, additionalWidgetProperties) {
    //set up range logic?
  return useConnector(connectRange, props,additionalWidgetProperties);
}

export function CustomRangeSlider (props){
  const {
    start,
    canRefine,
    range,
    refine,
  } = useRangeSlider(props, {});

  const currentVals = { 
    min: range.min ? range.min : range.min, 
    max: range.max ? range.max : (Math.floor(Date.now() / 1000)), 
  };
 
  const [value, setValues] = React.useState([currentVals.min, currentVals.max]);  

  // const minDistance = 100000;
  const minDistance = 0;

  // function debounce(func, wait) {
  //   let timeout;
  //   return function() {
  //     const context = this;
  //     const args = arguments;
  //     const later = function() {
  //       timeout = null;
  //       func.apply(context, args);
  //     };
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //   };
  // };

  const onRangeSubmit = (min, max) => {
    // console.log('min',min)
    // console.log('max',max)
  
    refine([
      Number.isFinite(min) ? min : undefined,
      Number.isFinite(max) ? max : undefined,
    ]);
  }

  const updateQueryRefine = (event, newValue, activeThumb) => {
    // console.log('event',event);
    // console.log('newv',newValue);
    // console.log('activeThumb',activeThumb);
    onRangeSubmit(newValue[0], newValue[1])
  }

  const updateSliderUI = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValues([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValues([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
  }

  const transformDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${
      date.getMonth() + 1
    }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  }

  function displayDate(value) {
    // return value;
    return `${transformDate(value)}`;
  }
  
  function rng_formatDate_display(timestamp){
    const date = new Date(timestamp * 1000);
    const options = { year: "numeric", month: "short", day: "numeric" }

    return date.toLocaleDateString(undefined, options);
  };

  
  return  range ? (
    <div className="rangeContainer">
      <Slider
        min={currentVals.min}
        max={currentVals.max}
        value={value}
        onChangeCommitted={updateQueryRefine}
        onChange={updateSliderUI}
        valueLabelDisplay="auto"
        getAriaLabel={() => 'Date Range'}
        getAriaValueText={displayDate}
        valueLabelFormat={displayDate}
        disableSwap
      />
      <div className="date-display">
        <div className="start">{rng_formatDate_display(value[0])}</div>
        <div className="end">{rng_formatDate_display(value[1])}</div>
      </div>
    </div>
    
  ) : (
    <div className="ais-RefinementList-item">No results.</div>
  );
}
